type ColorsObject = string | { [key: string]: ColorsObject }

export const makeColors = (
  colors: Record<string, ColorsObject>,
  transformers: ColorTransformer[] = colorTransformers,
) => {
  const final: Record<string, unknown> = {}

  const processColor = (colorObject: ColorsObject, path: string[]) => {
    if (typeof colorObject === 'string') {
      for (const transformer of transformers) {
        const { key, value } = transformer(colorObject, path)
        final[key] = value
      }
    } else {
      for (const [subKey, subValue] of Object.entries(colorObject)) {
        processColor(subValue, [...path, subKey])
      }
    }
  }

  processColor(colors, [])

  return {
    ...colors,
    ...final,
  } as any
}

type ColorTransformer = (color: string, path: string[]) => { key: string; value: any }

const colorTransformers: ColorTransformer[] = [
  (color: string, path: string[]): { key: string; value: { main: string } } => ({
    key: path.map(v => v.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()).join('-'),
    value: { main: color.toUpperCase() },
  }),
]
